import React, { useState } from "react";
import { formatLocalTime, formatTime, toBool, validateEmail } from "../../JS/utility";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { popupOpenClose } from "../../../action/action";
import { CMSPath } from "../../../config/constant";



const ResReservationV2_2c = (props) => {

    const { t } = props;
    const room = localStorage.getItem("room");
    const [addionalDetailsData, setAdditionalDetailsData] = useState({
        "firstName": "",
        "lastName": "",
        "email": "",
        "phoneNumber": "",
        "guestComment": ""
    })

    const handleBack = () => {
        props.goBack();
    }

    const handleNext = () => {

        if (!props.myReservationDataPresent) {

            if (addionalDetailsData.lastName == "") {
                props.popupOpenClose(true, t('resReservationV2.enter_last_name'))
                return;
            }

            if (addionalDetailsData.email == "") {
                props.popupOpenClose(true, t('resReservationV2.enter_email'))
                return;
            }

            if (!validateEmail(addionalDetailsData.email)) {
                props.popupOpenClose(true, "Please enter a valid email address");
                return;
            }

            if (addionalDetailsData.phoneNumber == "") {
                props.popupOpenClose(true, t('resReservationV2.enter_phone'))
                return;
            }
    
            if (isNaN(+addionalDetailsData.phoneNumber)) {
                props.popupOpenClose(true, "Please enter a valid phone number");
                return;
            }
        }


        props.next(addionalDetailsData)
    }

    const updateDataFromProps = () => {
        setAdditionalDetailsData({ ...addionalDetailsData, firstName: props.preferredVenueDetails.firstName, lastName: props.preferredVenueDetails.lastName, email: props.preferredVenueDetails.email, phoneNumber: props.preferredVenueDetails.phoneNumber ,guestComment: props.preferredVenueDetails.guestComment })
    }

    React.useEffect(() => {
        updateDataFromProps();
    }, [])

    return (
        <>
            <section class="widgets spa-listing spa-details">

                <div class="widget-header">
                    {props.currentWidgetObj.widgetHeaderImageUrl &&
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{props.selectedVenueData.name}</div>
                    <div>{t(`resReservationV2.heading2a`)}</div>
                </div>

                <div class="widgets">
                    <div class="row margin-bottom-2">
                        <div class="row">
                            <div class="col">

                                <div class="detail-body stay-body">
                                    <form>

                                        {(!room || room == "null") &&
                                            <div class="form-row">
                                                <p class="heading">{t('resReservationV2.first_name')} <span style={{ color: "red" }}>*</span></p>
                                                <input type="text" name="firstName" autoComplete='given-name' disabled={props.myReservationDataPresent} value={addionalDetailsData.firstName} onChange={(e) => setAdditionalDetailsData({...addionalDetailsData, firstName: e.target.value})} placeholder={t('resReservationV2.first_name_placeholder')} />
                                            </div>
                                        }

                                        {(!room || room == "null") &&
                                            <div class="form-row">
                                                <p class="heading">{t('resReservationV2.last_name')} <span style={{ color: "red" }}>*</span></p>
                                                <input type="text" name="lastName"  autoComplete='family-name' disabled={props.myReservationDataPresent} value={addionalDetailsData.lastName} onChange={(e) => setAdditionalDetailsData({...addionalDetailsData, lastName: e.target.value})} placeholder={t('resReservationV2.last_name_placeholder')} />
                                            </div>
                                        }

                                        <div class="form-row">
                                            <p class="heading">{t('resReservationV2.email')} <span style={{ color: "red" }}>*</span></p>
                                            <input type="text" name="email" autoComplete='email' disabled={props.myReservationDataPresent} value={addionalDetailsData.email} onChange={(e) => setAdditionalDetailsData({...addionalDetailsData, email: e.target.value})} placeholder={t('resReservationV2.email_placeholder')} />
                                        </div>

                                        <div class="form-row">
                                            <p class="heading">{t('resReservationV2.phone')} <span style={{ color: "red" }}>*</span></p>
                                            <input type="tel" name="phone" autoComplete="tel" disabled={props.myReservationDataPresent}  maxLength={14} value={addionalDetailsData.phoneNumber} onChange={(e) => setAdditionalDetailsData({...addionalDetailsData, phoneNumber: e.target.value})} placeholder={t('resReservationV2.phone_placeholder')} />
                                        </div>

                                        <div class="form-row">
                                            <p class="heading">{t('resReservationV2.special_request')}</p>
                                            <textarea rows="5" value={addionalDetailsData.guestComment} onChange={(e) => setAdditionalDetailsData({...addionalDetailsData, guestComment: e.target.value})} placeholder={t('resReservationV2.special_request_placeholder')}></textarea>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-controls">
                                <button onClick={handleNext}>{t('resReservationV2.make_reservation')}</button>
                                <button onClick={handleBack}>{t('resReservationV2.back')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        timeFormat: state.store.home.clientConfig.extraConfigParam && state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        serverTimeDate: state.store.home.serverTimeDate.date,
        menuColor: state.store.home.MenuColor,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT : "",
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        gmtOffset: state.store.home.serverTimeDate.gmtOffset,
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM
    }
}

export default connect(mapStateToProps, { popupOpenClose })(withTranslation('translations')(ResReservationV2_2c));